<style lang="less" scoped>
.container-div {}

.title-div {
  font-weight: 600;
  margin: 20px 10px 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}

.header-dropdown {
  color: #4182EB;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px 10px 20px;

  .header-container-name {
    height: 30px;
    line-height: 30px;
  }
}

.pileItem-div {
  font-weight: 600;
  margin: 0 10px !important;
  font-size: 20px;
  // flex-grow: 1;
  color: #000;
  // height: 30px;
}

.el-form-item {
  margin-bottom: 0;
  margin-left: 10px;
}

/deep/.el-form-item__label {
  text-align: left !important;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #8F9BB3;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.custInfo_container {
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item {
    width: 25%;
  }
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;

  >div:first-of-type {
    // width: 120px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }

  >div:last-of-type {
    font-size: 14px;
    min-width: 160px;
    // text-align: right;
  }
}

.cust-detail-title {
  // text-align: ;
  // margin-right: 50px;
  // width: 150px;
}

// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
  margin-bottom: 10px;
}

.cust-mes {
  margin: 0px 0px 14px 18px;
}

.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}

.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}

.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}

.xieyi {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding-left: 5px;
  border-radius: 4px;
  background-color: #F5F7FA;
  border: 1px solid #E4E7ED;
  color: #C0C4CC;
}

#mapDom {
  width: 1000px;
  height: 650px;
}
</style>

<template>
  <div class="detail-content-div">
    <div class="title-div">
      充电桩信息
      <el-dropdown @command="handleCommand">
        <div class="flex-r header-dropdown">
          <p class="header-container-name">{{ custInfo.pileCode }}</p>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="i in pileList" :key="i.pileType" :command="i.pileType">
            {{ i.pileType}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-form :model="pileInfo" ref="formForm" label-width="120px" class="detail-form">
      <el-row :gutter="20">
        <el-col :span="24"> <span class="pileItem-div">基础信息</span> </el-col>
        <el-col :span="8">
          <el-form-item label="成品料号">
            <el-select class="full-width" size="small" v-model="pileInfo.materialNo" placeholder="请选择" @change="handleMaterialNoChange">
              <el-option v-for="(item, index) in materialList" :key="index" :label="item.materialNo" :value="item.materialNo" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="充电桩名称">
            <el-input type="text" size="small" disabled v-model="pileInfo.shareStationName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="充电桩显示名称">
            <el-input type="text" size="small" disabled v-model="pileInfo.showName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="充电桩型号">
            <el-input type="text" size="small" disabled v-model="pileInfo.pileTypeName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="规格">
            <el-input type="text" size="small" disabled v-model="pileInfo.specificationName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="充电桩编号">
            <el-input type="text" size="small" disabled v-model="pileInfo.pileNo" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="IMEI编号">
            <el-input type="text" size="small" disabled v-model="pileInfo.pileCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否开通共享">
            <el-input type="text" size="small" disabled v-model="pileInfo.shareActiveName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="当前共享状态">
            <el-input type="text" size="small" disabled v-model="pileInfo.shareModeName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="共享开关实时状态" label-width="150px">
            <el-input type="text" size="small" disabled v-model="pileInfo.shareListLocalStatus" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="共享列表状态">
            <el-input type="text" size="small" disabled v-model="pileInfo.shareListStatus" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="绑定渠道">
            <el-input type="text" size="small" disabled v-model="pileInfo.bindChannelName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所属用户">
            <el-input type="text" size="small" disabled v-model="pileInfo.custPhone" />
          </el-form-item>
        </el-col>
         <el-col :span="8">
          <el-form-item label="绑定时间">
            <el-input type="text" size="small" disabled v-model="pileInfo.bindTime" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开通共享时间">
            <el-input type="text" size="small" disabled v-model="pileInfo.openShareActiveTime" />
          </el-form-item>
        </el-col>
        <!-- openShareActiveTime -->
        <!-- <el-col :span="8">
          <el-form-item label="质保有效期">
            <el-date-picker v-model="pileInfo.warrantyEndTime" type="datetime" size="small" style="width: 78%;"
              value-format="yyyy-MM-dd HH:mm:ss" prefix-icon="el-icon-date" placeholder="选择日期时间">
            </el-date-picker>
            <span style="padding-left: 12px;box-sizing: border-box; color: #bb87f3; cursor: pointer;"
              @click="handleHistroy(true)">历史记录</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联网订阅有效期">
            <el-date-picker v-model="pileInfo.networkEndTime" type="datetime" size="small" style="width: 78%;"
              value-format="yyyy-MM-dd HH:mm:ss" prefix-icon="el-icon-date" placeholder="选择日期时间">
            </el-date-picker>
            <span style="padding-left: 12px;box-sizing: border-box; color: #bb87f3; cursor: pointer;"
              @click="handleHistroy(false)">历史记录</span>
          </el-form-item>
        </el-col> -->
        
        <el-col :span="24"><span class="pileItem-div">参数信息</span></el-col>
        <el-col :span="8">
          <el-form-item label="厂商代码">
            <el-input type="text" size="small" disabled v-model="pileInfo.manufactorCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="业务归属">
            <el-input type="text" size="small" disabled v-model="pileInfo.businessBelongName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="存货大类名称">
            <el-input type="text" size="small" disabled v-model="pileInfo.bigName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="额定电流">
            <el-input type="text" size="small" disabled v-model="pileInfo.ratedCurrent" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="额定电压">
            <el-input type="text" size="small" disabled v-model="pileInfo.ratedVoltage" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="额定功率">
            <el-input type="text" size="small" disabled v-model="pileInfo.ratedPower" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单项桩/三项桩">
            <el-input type="text" size="small" disabled v-model="pileInfo.phaseTypeName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="充电枪数量">
            <el-input type="text" size="small" disabled v-model="pileInfo.gunNum" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="充电速度">
            <el-input type="text" size="small" disabled v-model="pileInfo.chargingSpeedName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="接口类型">
            <el-input type="text" size="small" disabled v-model="pileInfo.interfaceTypeName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电流输出类型">
            <el-input type="text" size="small" disabled v-model="pileInfo.currentOutTypeName" />
          </el-form-item>
        </el-col>
        <el-col :span="24"><span class="pileItem-div">功能信息</span></el-col>
        <el-col :span="8">
          <el-form-item label="蓝牙功能">
            <el-select class="full-width" size="small" v-model="pileInfo.bluetoothFlag" clearable disabled placeholder="请选择">
              <el-option label="有" value="Y"></el-option>
              <el-option label="无" value="N"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="即插即充">
            <el-select class="full-width" size="small" v-model="pileInfo.offHandChargingFlag" clearable disabled
              placeholder="请选择">
              <el-option label="有" value="Y"></el-option>
              <el-option label="无" value="N"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="无感充电">
            <el-select class="full-width" size="small" v-model="pileInfo.cardFlag" clearable disabled placeholder="请选择">
              <el-option label="有" value="Y"></el-option>
              <el-option label="无" value="N"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="音频">
            <el-select class="full-width" size="small" v-model="pileInfo.audioType" clearable disabled
              placeholder="请选择">
              <el-option label="无" value="00"></el-option>
              <el-option label="蜂鸣器" value="01"></el-option>
              <el-option label="扬声器" value="02"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联网方式">
            <el-select class="full-width" size="small" v-model="pileInfo.networkStatus" clearable disabled
              placeholder="请选择">
              <el-option label="4G" value="01"></el-option>
              <el-option label="4G+WIFI" value="02"></el-option>
              <el-option label="无" value="03"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="蓝牙配置">
            <el-select class="full-width" size="small" v-model="pileInfo.bluetoothPairFlag" clearable disabled
              placeholder="请选择">
              <el-option label="有配对" value="Y"></el-option>
              <el-option label="无配对" value="N"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="蓝牙协议">
            <el-input type="text" size="small" disabled v-model="pileInfo.bluetoothVersion" />
          </el-form-item>
        </el-col>
        <el-col :span="24" ><span class="pileItem-div">物联网卡及质保信息</span></el-col>
        <el-col :span="8" >
          <el-form-item label="物联网卡号">
            <el-input type="text" size="small" disabled v-model="pileInfo.cardNo" />
          </el-form-item>
        </el-col>
        <el-col :span="8" >
          <el-form-item label="业务激活时间">
            <el-input type="text" size="small" @input="changeBind" v-model="pileInfo.bindTime" />
          </el-form-item>
        </el-col>
        <el-col :span="8" >
          <el-form-item label="流量赠送时间">
            <el-select @change="changeTimeStatus" class="full-width" size="small" v-model="pileInfo.networkTimeStatus"
              placeholder="请选择">
              <el-option label="1年" value="01"></el-option>
              <el-option label="2年" value="02"></el-option>
              <el-option label="5年" value="03"></el-option>
              <el-option label="10年" value="04"></el-option>
              <el-option label="无期限" value="05"></el-option>
            </el-select>
            <!-- <el-input type="text"  size="small" @input="changeTimeStatus"  v-model="pileInfo.networkTimeStatusName" /> -->
          </el-form-item>
        </el-col>
        <el-col :span="8" >
          <el-form-item label="质保赠送时间">
            <el-select @change="changewarrantyTime" class="full-width" size="small"
              v-model="pileInfo.warrantyTimeStatus" placeholder="请选择">
              <el-option label="2年" value="01"></el-option>
              <el-option label="4年" value="02"></el-option>
              <el-option label="无期限" value="03"></el-option>
            </el-select>
            <!-- <el-input type="text"  size="small"  v-model="pileInfo.warrantyTimeStatusName" /> -->
          </el-form-item>
        </el-col>
        <el-col :span="8" >
          <el-form-item label="预计离网时间">
            <el-input type="text" size="small" @input="changeNetwork" v-model="pileInfo.networkEndTime" />
          </el-form-item>
        </el-col>
        <el-col :span="8" >
          <el-form-item label="质保到期时间">
            <el-input type="text" size="small" @input="changeWarranty" v-model="pileInfo.warrantyEndTime" />
          </el-form-item>
        </el-col>
        <el-col :span="24" >
          <div style="display:inline-block;margin:0 30px 10px 10px;color:#8f9bb3">物联网卡及质保历史记录</div>
          <div style="color:#6d9ef3;text-decoration:underline;cursor: pointer;display:inline-block;"
            @click="getIotHistory">详细信息</div>
        </el-col>
        <el-col :span="24" ><span class="pileItem-div">嵌入式软件信息</span></el-col>
        <el-col :span="8" >
          <el-form-item label="软件版本号">
            <el-input type="text" size="small" disabled v-model="custInfo.softVersion" />
          </el-form-item>
        </el-col>
        <el-col :span="8" >
          <el-form-item label="协议类型">
            <div class="xieyi">桩到家协议</div>
          </el-form-item>
        </el-col>
        <el-col :span="8" >
          <el-form-item label="协议版本号">
            <el-input type="text" size="small" disabled v-model="custInfo.protocolVersion" />
          </el-form-item>
        </el-col>
        <el-col :span="24" ><span class="pileItem-div">充电桩位置信息</span></el-col>
        <el-col :span="8" >
          <el-form-item label="经纬度">
            <el-input type="text" size="small" disabled v-model="custInfo.lonLat" />
          </el-form-item>
        </el-col>
        <el-col :span="24" >
          <div id="mapDom"></div>
        </el-col>
        <el-col :span='24' class="text-right">
          <button type="button" class="common-bg-button" @click="handelEdit()">保 存</button>
          <button type="button" class="common-empty-button" @click="back()">返 回</button>
        </el-col>
        <el-dialog :visible.sync="hisDialogVisible" title="到期时间" width="60%">
          <div class="phone">
            <el-table class="el-table" :data="historyList" border max-height="400px"
              style="width: 100%;margin:0px auto 20px" :cell-style="{ 'text-align': 'center' }"
              :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
              <el-table-column v-if="historyFlag" prop="warrantyEndTime" label="质保到期时间">
                <template slot-scope="scope">
                  <el-date-picker v-model="scope.row.warrantyEndTime" @change='submitEndTime(scope.row.warrantyEndTime)'
                    type="datetime" size="small" :disabled='!scope.row.warrantyEndTime' prefix-icon="el-icon-date"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column v-else prop="networkEndTime" label="联网到期时间">
                <template slot-scope="scope">
                  <el-date-picker v-model="scope.row.networkEndTime" type="datetime" size="small"
                    :disabled='!scope.row.networkEndTime' @change='submitEndTime(scope.row.networkEndTime)'
                    prefix-icon="el-icon-date" placeholder="选择日期时间">
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column prop="lastModifiedByName" label="修改人" />
              <el-table-column prop="lastModifiedWhen" label="修改时间" />
            </el-table>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="infoDialogVisible" title="物联网卡及质保历史记录" width="60%">
          <div class="phone">
            <el-table class="el-table" :data="pileInfo.payList" border max-height="400px"
              style="width: 100%;margin:0px auto 20px" :cell-style="{ 'text-align': 'center' }"
              :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
              <el-table-column prop="walletListNo" width="120" label="购买订单编号" />
              <el-table-column prop="equityContent" label="购买类型" />
              <el-table-column prop="packagName" label="购买套餐" />
              <el-table-column prop="pileUseServiceName" label="购买内容" />
              <el-table-column prop="renewalContent" label="续费内容" />
              <el-table-column prop="transactionCreateTime" label="购买时间" />
              <el-table-column prop="networkBeforeBuyEndTime" width="160" label="购买前预计到期时间" />
              <el-table-column prop="networkAfterBuyEndTime" width="160" label="购买后预计到期时间" />
            </el-table>
          </div>
        </el-dialog>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';
import pageConfig from '../cust-manage/page-config'
// import "echarts/map/js/china.js";
import pileMapMarkerIcon from '../../../assets/dashboard/pile.png'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      custInfo: {},
      isCustInfo: false,
      hisDialogVisible: false,
      infoDialogVisible: false,
      pileList: [],
      pileInfo: {
        pileCode: '',
      },

      // 车辆信息数据
      carInfoTable: [],
      carPagination: pageConfig.carPagination,
      mapMarkers: [],
      map: '',
      historyFlag: false,
      historyList: [],
      editInfo: {
        pileFunctionEntity: {},
        pileBindTimeEntity: {},
      },
      materialList: [],
    }
  },
  methods: {
    changewarrantyTime(val) {
      this.editInfo.pileFunctionEntity.warrantyTimeStatus = val
      if (val == '01') {
        this.editInfo.pileFunctionEntity.warrantyTimeStatusName = '2年'
      } else if (val == '02') {
        this.editInfo.pileFunctionEntity.warrantyTimeStatusName = '4年'
      } else {
        this.editInfo.pileFunctionEntity.warrantyTimeStatusName = '无期限'
      }
    },
    changeBind(val) {

      this.editInfo.pileBindTimeEntity.bindTime = val
      console.log(this.editInfo.pileBindTimeEntity.bindTime);
    },
    changeTimeStatus(val) {
      this.editInfo.pileFunctionEntity.networkTimeStatus = val
      if (val == '01') {
        this.editInfo.pileFunctionEntity.networkTimeStatusName = '1年'
      }
      if (val == '02') {
        this.editInfo.pileFunctionEntity.networkTimeStatusName = '2年'
      }
      if (val == '03') {
        this.editInfo.pileFunctionEntity.networkTimeStatusName = '5年'
      }
      if (val == '04') {
        this.editInfo.pileFunctionEntity.networkTimeStatusName = '10年'
      }
      if (val == '05') {
        this.editInfo.pileFunctionEntity.networkTimeStatusName = '无期限'
      }
    },
    changeNetwork(val) {
      this.editInfo.pileBindTimeEntity.networkEndTime = val
    },
    changeWarranty(val) {
      this.editInfo.pileBindTimeEntity.warrantyEndTime = val
    },

    init() {
      let _ = this;
      // 列表“查看”入口：路由 query 携带桩号，优先级最高——URL 明确、可刷新可分享，
      // 且不受 localStorage 中历史残留的 custObj/pileObj 影响（串桩根因）
      const routePileCode = this.$route.query.pileCode;
      if (routePileCode) {
        // 展示字段（经纬度/桩名称等）来自跳转时写入 store 的列表行对象；
        // 仅当行桩号与 query 一致时采用，防止残留行混入（如直接打开收藏的旧 URL）
        if (this.$store.state.pileObj && this.$store.state.pileObj.pileCode === routePileCode) {
          this.custInfo = this.$store.state.pileObj
          this.custInfo.pileNo = this.$store.state.pileObj.pileNo
          this.custInfo.pileTypeNo = this.$store.state.pileObj.pileTypeNo
          this.custInfo.pileName = this.$store.state.pileObj.pileName
          this.custInfo.lonLat = this.$store.state.pileObj.lonLat
          this.custInfo.lat = this.$store.state.pileObj.lat
          this.custInfo.lon = this.$store.state.pileObj.lon
          this.initmap(this.custInfo.lat, this.custInfo.lon)
          this.pileInfo.pileNo = this.$store.state.pileObj.pileNo
        }
        this.custInfo.pileCode = routePileCode;
        this.getFormInfo();
      } else if (this.$store.state.custObj) {
        this.custInfo = this.$store.state.custObj
        this.custInfo.pileCodes?.forEach(item => {
          let obj = {
            pileType: item
          }
          this.pileList.push(obj)
        })
        this.custInfo.pileCode = this.custInfo.pileCodes[0]
        this.isCustInfo = true
        if (this.custInfo.pileCode) {
          this.getInfo()
        }
      } else if (this.$store.state.pileObj) {
        this.custInfo = this.$store.state.pileObj
        this.custInfo.pileCode = this.$store.state.pileObj.pileCode
        this.custInfo.pileNo = this.$store.state.pileObj.pileNo
        this.custInfo.pileTypeNo = this.$store.state.pileObj.pileTypeNo
        this.custInfo.pileName = this.$store.state.pileObj.pileName
        this.custInfo.lonLat = this.$store.state.pileObj.lonLat
        this.custInfo.lat = this.$store.state.pileObj.lat
        this.custInfo.lon = this.$store.state.pileObj.lon
        this.initmap(this.custInfo.lat, this.custInfo.lon)
        this.getFormInfo()
        this.pileInfo.pileNo = this.$store.state.pileObj.pileNo
      }

      // 获取成品料号下拉数据
      _.$H.post(_, _.$A.digitization.getMaterialNoList, {}).then(res => {
        _.materialList = res.data.data || [];
      })

    },
    // 获取详情-充电桩
    getFormInfo() {
      let _ = this;
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.digitization.getPileInfo, { pileCode: this.custInfo.pileCode }).then((res) => {
        _.pileInfo = res.data.data || {}
        if (!_.pileInfo.openShareActiveTime && _.custInfo.openShareActiveTime) {
          _.pileInfo.openShareActiveTime = _.custInfo.openShareActiveTime
        }
        _.$U.hideLoading(_);
      })
    },

    // 获取详情-用户
    getInfo() {
      let _ = this;
      _.$H.post(_, _.$A.cust.getPileInfo, { pileCode: this.custInfo.pileCode }).then((res) => {
        _.pileInfo = res.data.data
        if (!_.pileInfo.openShareActiveTime && _.custInfo.openShareActiveTime) {
          _.pileInfo.openShareActiveTime = _.custInfo.openShareActiveTime
        }
      })
    },

    getIotHistory() {
      let _ = this
      _.$H.post(_, _.$A.pile.pileUseWalletListHistory, { pileCode: _.custInfo.pileCode }).then((res) => {
        _.pileInfo.payList = res.data.data
        this.infoDialogVisible = !this.infoDialogVisible
      })
    },
    handleHistroy(flag) {
      let _ = this
      _.$H.post(_, _.$A.pile.listHistory, { pileCode: _.custInfo.pileCode, bindPhone: _.custInfo.mobile, flag: flag }).then((res) => {
        _.historyList = res.data.data
        console.log(_.historyList);
        this.historyFlag = flag
        this.hisDialogVisible = !this.hisDialogVisible
      })
    },
    submitEndTime(time) {
      let _ = this
      let obj = {
        pileCode: _.custInfo.pileCode,
        bindPhone: _.pileInfo.bindPhone,
      }
      if (_.historyFlag) {
        obj.warrantyEndTime = time
        delete obj.networkEndTime
      } else {
        obj.networkEndTime = time
        delete obj.warrantyEndTime
      }
      _.$H.post(_, _.$A.pile.editBindTime, obj).then((res) => {
        // _.historyList = res.data.data
        this.infoDialogVisible = !this.infoDialogVisible
      })
    },

    handleCommand(val) {
      this.custInfo.pileCode = val;
      if (this.isCustInfo) {
        this.getInfo()
      } else {
        this.getFormInfo()
      }
    },
    back() {
      if (this.isCustInfo) {
        this.$router.push({
          name: "custList"
        })
      } else {
        this.$router.push({
          name: "pileList"
        })
      }
      // this.$router.go(-1)
    },
    // init地图
    initmap(lat, lon) {
      let _ = this;
      _.map = new AMap.Map("mapDom", {
        resizeEnable: true,
        zoom: 9, //级别
        center: [121.014358, 31.377824], //中心点坐标
        mapStyle: "amap://styles/whitesmoke", //设置地图的显示样式
      });
      //添加地图控件
      AMap.plugin("AMap.ToolBar", function () {
        //异步加载插件
        let toolopt = {
          offset: new AMap.Pixel(10, 10),//相对于地图容器左上角的偏移量，正数代表向右下偏移。默认为AMap.Pixel(10,10)
          position: 'RT',
        }
        var toolbar = new AMap.ToolBar(toolopt);
        _.map.addControl(toolbar);
      });
      // return
      if (lat && lon) {
        _.mapMarkers = [];
        // let itemLat = lat;
        // let itemLon = lon;
        // const lon = parseFloat(itemLon).toFixed(6);
        // const lat = parseFloat(itemLat).toFixed(6);
        // const gdLonlat = gps.gcj_encrypt(
        //   parseFloat(lat),
        //   parseFloat(lon)
        // );
        let marker = "";
        marker = new AMap.Marker({
          map: _.map,
          icon: pileMapMarkerIcon,
          position: [lon, lat],
          offset: new AMap.Pixel(-17, -20),
          title: this.pileInfo.pileTypeName,
        });
        _.map.add(marker)
        marker.on('click', this.markerClick)
        // 将创建的点标记添加到已有的地图实例：
        _.mapMarkers.push(marker);
        let positions = [];
        positions.push([121.014358, 31.377824])
        positions.push([lon, lat])
        var polygon = new AMap.Polygon({
          path: positions,  //以5个点的坐标创建一个隐藏的多边形
          map: _.map,
          strokeOpacity: 0,//透明
          fillOpacity: 0,//透明
          bubble: true//事件穿透到地图
        });
        var overlaysList = _.map.getAllOverlays('polygon');//获取多边形图层
        // //2.使用setFitView方法
        _.map.setFitView(overlaysList);//自适应显示
      }
    },
    //点击编辑
    openInput() {
      this.btnShow = false
      this.editShow = true
      this.remarkShow = false
      this.inputShow = true
      //this.detailForm.remark = '';
    },
    // 选中成品料号后联动对应的桩型号，保证提交时料号与型号成对
    handleMaterialNoChange(materialNo) {
      const _ = this
      const selected = _.materialList.find(item => item.materialNo === materialNo)
      if (selected && selected.pileTypeNo) {
        _.pileInfo.pileTypeNo = selected.pileTypeNo
      }
    },
    //保存编辑内容
    handelEdit() {
      let _ = this
      if (!this.isCustInfo) {
        let params = _.custInfo
        params.pileTypeNo = _.pileInfo.pileTypeNo
        params.materialNo = _.pileInfo.materialNo
        params.pileFunctionEntity = _.editInfo.pileFunctionEntity
        params.pileBindTimeEntity = _.editInfo.pileBindTimeEntity
        console.log(_.editInfo, _.pileInfo);
        _.$U.showLoading(_)
        axios.post(_.$A.digitization.editPile, params, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'authorization': _.$store.state.token
          },
          // timeout: config.httpTimeOut
        }).then(res => {
          _.$U.success('编辑成功')
          console.log(res);
          _.init()
          _.$U.hideLoading(_)
          // custResponseFun(vm, res, resolve);
        })
          .catch(err => {
            console.log(err);
            _.$U.success('编辑成功')
            // custErrFun(vm, err);
          })      // _.custInfo.pileTypeNo = _.pileInfo.pileTypeNo
        // _.back()
      } else {
        let obj = {
          bindPhone: _.custInfo.mobile,
          pileCode: _.custInfo.pileCode,
          warrantyEndTime: _.pileInfo.warrantyEndTime,
          networkEndTime: _.pileInfo.networkEndTime
        }
        _.$H.post(_, _.$A.pile.editBindTime, obj).then(res => {
          console.log(res);
          _.$U.success('编辑成功')
          _.init()
          _.$U.hideLoading(_)
        })
      }

    },
  },
  mounted() {
    this.init()
  },
}
</script>
